module.exports = __webpack_public_path__ + "static/media/0@2x.c5b0b9e5.png";